import {ws} from '../websocket/index'
import {getUid} from '../utils/index'
import {getStockProfile} from '../api'
import store from './index'

function isCurrentStock (obj) {
  return getUid(obj) === getUid({
    market: store.state.market,
    code: store.state.code
  })
}
ws.websocket.on('onSTATIC', msg => {
  store.commit('setStatic', msg.QuoteData.StaticData[0])
})

ws.websocket.on('onSTATUS', msg => {
  store.commit('setStatus', msg.QuoteData.InstStatusData[0].StatusType)
})

ws.websocket.on('onSTATISTICS', msg => {
  let tmpMarket = msg.Market.replace('DELAY_', '')
  if(!isCurrentStock({market: tmpMarket, code: msg.Inst})) return
  store.commit('setStatistics', msg.QuoteData.StatisticsData[0])
})

ws.websocket.on('onDYNA', msg => {
  let tmpMarket = msg.Market.replace('DELAY_', '')
  if(!isCurrentStock({market: tmpMarket, code: msg.Inst})) return
  store.commit('setDyna', msg.QuoteData.DynaData[0])
})

ws.websocket.on('onTICK', msg => {
  let tmpMarket = msg.Market.replace('DELAY_', '')
  if(!isCurrentStock({market: tmpMarket, code: msg.Inst})) return
  store.commit('setTick', msg.QuoteData.TickData)
})

export default {
  async subscribe (code, market, region,type) {
    console.log('region:', region)
    let tmpMarket = region.indexOf('US') > -1 ? 'DELAY_'+ market: market
    ws.websocket.safeSubscribeSTATISTICS(code, tmpMarket,type)
    ws.websocket.safeSubscribeDYNA(code, tmpMarket,type)
    ws.websocket.safeSubscribeTICK(code, tmpMarket)
    ws.websocket.safeSubscribeSTATUS(code, tmpMarket)
    region !== 'CN' && ws.websocket.safeSubscribeSTATIC(code, tmpMarket)
    const res = await getStockProfile(market + code)
    store.commit('setProfile', res.ShareholderEquity)
  }
}